<template>
  <div class="uk-flex">
    <Main />
  </div>
</template>

<script>
import Main from '../components/TransportChainComponents/WizardMain'

export default {
  name: 'Home',
  components: {
    Main
  },
  data () {
    return {
      items: []
    }
  }
}
</script>

<style scoped>
.uk-flex{
  margin: 10px auto;
}
</style>
